import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button } from '@mui/material';
import { type FC, useState } from 'react';

import CameraVisionSnippetsDialog from './CameraVisionSnippetsDialog.js';

interface Props {
  cameraId: string;
  cameraName: string;
}

const CameraVisionSnippetsButton: FC<Props> = ({ cameraId, cameraName }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="small" variant="outlined" startIcon={<VisibilityIcon fontSize="small" />} onClick={() => setOpen(true)}>
        Vision
      </Button>
      {open && <CameraVisionSnippetsDialog cameraId={cameraId} cameraName={cameraName} onClose={() => setOpen(false)} />}
    </>
  );
};

export default CameraVisionSnippetsButton;
